<template>
  <div class="padding-x fg-2 margin-auto">
    <div class="max-1200">
      <div class="big-body">Products</div>
      <div class="gap-3x"></div>
      <div class="line-break-gray"></div>
      <div v-if="error && !notice">
        <div class="gap-3x" />
        <div class="error-message cart">{{error}}</div>
        <div class="gap-3x" />
        <div class="line-break-gray" />
      </div>
      <div v-if="notice && !error">
        <div class="gap-3x" />
        <div class="error-message cart">{{notice}}</div>
        <div class="gap-3x" />
        <div class="line-break-gray" />
      </div>

      <div v-for="item in availableItems" :key="item.name">
        <div class="gap-3x"></div>
        <div class="flex-box wrap">
          <div class="item-description">
            <div class="bold">{{item.name}}</div>
            <div>
              <label>{{item.text}}</label>
              <label v-html="'&nbsp;'"></label>
              <label><a :href="item.href" target="_blank" class="link active text-like">{{item.linkText}}</a></label>
            </div>
          </div>
          <div class="item-action">
            <SymbiumButton
              :text="ovalButtonText(item.addedToCart)"
              :onClick="() => toggleSelectItem(item)"
              :isPrimary="item.addedToCart"
              :isSmall="true"
            />
          </div>
        </div>
        <div class="gap-3x"></div>
        <div class="line-break-gray"></div>
      </div>
    </div>
  </div>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import EventBus from '../EventBus.js'

export default {
  name: 'QuestionnaireContainer',
  props: ['availableItems', 'error'],
  components: { SymbiumButton },
  methods: {
    ovalButtonText(addedToCart) {
      return addedToCart ? 'Added' : 'Add to Cart'
    },
    toggleSelectItem(item) {
      var action = item.addedToCart ? 'removeItem' : 'addItem'
      item.addedToCart = !item.addedToCart;
      this.$cart[action](item.name);
      if(action == 'addItem') this.includeBuildIfNeed(item);
      if(action == 'removeItem') this.excludeBuildPlusIfNeed(item);
      EventBus.$emit(EventBus.onCartChangedEvent);
    },
    includeBuildIfNeed(item) {
      var buildItem = this.buildItem();
      if(this.$cart.isBuildPlus(item.name) && this.$questionnaire.shouldBuildIncluded() && !buildItem.addedToCart) {
        this.$cart.addItem(buildItem.name)
        buildItem.addedToCart = true
        this.notice = "Symbium Build+ is only available for jurisdictions covered by Symbium Build"
      }
    },
    excludeBuildPlusIfNeed(item) {
      var buildPlusItem = this.buildplusItem();
      if(this.$cart.isBuild(item.name) && this.$questionnaire.shouldBuildIncluded() && buildPlusItem.addedToCart) {
        this.$cart.removeItem(buildPlusItem.name)
        buildPlusItem.addedToCart = false
        this.notice = "Symbium Build+ is only available for jurisdictions covered by Symbium Build"
      }
    },
    buildItem() {
      return this.availableItems[0]
    },
    buildplusItem() {
      return this.availableItems[1]
    },
    cityChanged() {
      var buildItem = this.buildItem();
      var buildPlusItem = this.buildplusItem();

      if(!this.$questionnaire.shouldBuildIncluded()) {
        this.notice = null;
        this.$cart.removeItem(buildItem.name)
        buildItem.addedToCart = false
        EventBus.$emit(EventBus.onCartChangedEvent);
      }

      if(!buildItem.addedToCart && buildPlusItem.addedToCart) {
        this.includeBuildIfNeed(buildPlusItem)
        EventBus.$emit(EventBus.onCartChangedEvent);
      }
    },
    organizationTypeChange() {
      this.notice = null;
    },
  },
  data() {
    return {
      notice: null
    }
  },
  created() {
    EventBus.$on('city-changed', this.cityChanged)
    EventBus.$on('organization-type-changed', this.organizationTypeChange)
  },
  beforeDestroy() {
    EventBus.$off('city-changed', this.cityChanged)
    EventBus.$off('organization-type-changed', this.organizationTypeChange)
  },
}
</script>
<style lang="scss" scoped>
.item-action {
  flex-grow: 1;

  div.oval-button {
    padding: 8px 16px;
  }
  div.oval-button.inactive {
    padding: 7px 15px;
  }
}

.cart.error-message {
  font-size: 16px;
  line-height: 24px;
  margin-top: 0;
}

.item-description {
  width: calc(100% - 144px);
}
@media screen and (max-width: 960px) {
  .item-action {
    flex-grow: 0;
    min-width: auto;
    padding-top: 12px;
  }

  .item-description {
    width: calc(100% - 48px);
    margin-right: 24px;
  }
}
</style>
